export const HNDialogMicrowebFastlegepanelProject = 'HN.Dialog.Microweb.Fastlegepanel';
